module.exports = __webpack_public_path__ + "static/media/bulk_batch_wise_sample.d66538ad.csv";